import { useState, useEffect } from 'react';

const STORAGE_KEY = 'theme';

const getInitialDarkMode = (): boolean => {
    if (typeof window === 'undefined') return true;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark') return true;
    if (stored === 'light') return false;
    // Default to dark mode on first visit
    return true;
};

const DarkModeToggle = () => {
    const [darkMode, setDarkMode] = useState<boolean>(getInitialDarkMode);

    useEffect(() => {
        const root = document.documentElement;
        if (darkMode) {
            root.classList.add('dark');
            window.localStorage.setItem(STORAGE_KEY, 'dark');
        } else {
            root.classList.remove('dark');
            window.localStorage.setItem(STORAGE_KEY, 'light');
        }
    }, [darkMode]);

    return (
        <button
            type="button"
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-pressed={darkMode}
            onClick={() => setDarkMode((prev) => !prev)}
            className="fixed z-50 top-3 right-3 sm:top-4 sm:right-4 w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center
                       rounded-full bg-slate-200 dark:bg-slate-800 shadow-xl
                       hover:scale-110 transition-all cursor-pointer border border-slate-300 dark:border-slate-700"
        >
            <i className={`bx bx-${darkMode ? 'sun text-yellow-400' : 'moon text-slate-700'} text-xl`}></i>
        </button>
    );
};

export default DarkModeToggle;